module.exports = global["angular"] = require("-!/usr/lib/node_modules/source-map-loader/index.js!./index.js");